export const useDefaultData = ({ Helpers }) => {

    const {
        getCurrentDate,
        getCurrentStartMonth
    } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFilterForm = {
        startDate: getCurrentStartMonth(),
        endDate: getCurrentDate(),
        idcaja: 'ALL',
        movimiento_tipo: 'ALL'
    }

    const defaultFormScreen = {
        idmovimiento: '',
        idcategoria: '',
        idcaja: '',
        movimiento_fecha: getCurrentDate(),
        movimiento_usuario: '',
        movimiento_tipo: 'ALL',
        movimiento_monto: '',
        movimiento_moneda: '',
        movimiento_tipo_cambio: '7.80',
        movimiento_quetzales: '',
        movimiento_dolares: '',
        movimiento_observaciones: '',

        clean_movimiento_monto: 0,
        clean_movimiento_tipo_cambio: 7.8,
        clean_movimiento_quetzales: 0,
        clean_movimiento_dolares: 0,
    }

    return Object.freeze({
        defaultDataModal,
        defaultFilterForm,
        defaultFormScreen
    })
}